<div class="tableToolBar" fxLayout="row" fxLayoutAlign="start center">
  <ng-content></ng-content>
  <form fxFlex="20" [formGroup]="searchForm" novalidate
        class="list-search"
        joyrideStep="easySearch"
        title="Zoekfunctie"
        i18n-title
        text="Zoek in dit overzicht naar records door een woord in te voeren."
        i18n-text>
    <mat-form-field appearance="outline" color="accent" fxFlex="100">
      <mat-label i18n>Zoeken</mat-label>
      <input type="text" (keyup)="keyUpEventHandler($event)"
             formControlName="data"
             placeholder="Zoeken"
             i18n-placeholder
             matInput />
      <button
        *ngIf="searchForm.get('data').value !== ''"
        (click)="clearSearchText()"
        mat-icon-button
        matSuffix

      >
        <mat-icon> close </mat-icon>
      </button>
    </mat-form-field>
  </form>
</div>
